import { PipEntryPoint } from 'utils/pip/types';

export type PipRequestDiagnostics = {
  entry: PipEntryPoint;
  prepared: boolean;
  playDurationMs: number;

  userActivationActive: boolean | null;
  userActivationHasBeenActive: boolean | null;

  alreadyInPip: boolean;
  topLevel: boolean;
  pipEnabled: boolean;
  visibility: DocumentVisibilityState;
  focused: boolean;

  readyState: number;
  videoWidth: number;
  videoHeight: number;
};

type PipRequestOrigin = Pick<PipRequestDiagnostics, 'entry' | 'prepared' | 'playDurationMs'>;

export const extractPipRequestState = (
  video: HTMLVideoElement,
  { entry, prepared, playDurationMs }: PipRequestOrigin
): PipRequestDiagnostics => {
  const activation = (
    navigator as { userActivation?: { isActive: boolean; hasBeenActive: boolean } }
  ).userActivation;

  return {
    entry,
    prepared,
    playDurationMs,
    userActivationActive: activation?.isActive ?? null,
    userActivationHasBeenActive: activation?.hasBeenActive ?? null,
    alreadyInPip: document.pictureInPictureElement != null,
    topLevel: window.self === window.top,
    pipEnabled: document.pictureInPictureEnabled,
    visibility: document.visibilityState,
    focused: document.hasFocus(),
    readyState: video.readyState,
    videoWidth: video.videoWidth,
    videoHeight: video.videoHeight,
  };
};
